import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { GameStateSnapshot } from '@juegazo/shared';
import './background';

@customElement('jgz-waiting')
export class JgzWaiting extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: String }) roomId = '';
  @property({ type: Object }) state: GameStateSnapshot | null = null;

  render() {
    const bombNumber = this.state?.bombNumber ?? 0;
    const totalBombs = this.state?.totalBombs ?? 0;
    return html`
      <jgz-background></jgz-background>
      <div class="container fade-in" style="max-width: 480px; margin: 0 auto; position: relative; z-index: 1;">
        <div class="card" style="text-align: center;">
          <div style="font-size: 3.5rem;">⏳</div>
          <h1>Partida en curso</h1>
          <p>La partida ya comenzó. Cuando termine, podrás unirte.</p>
          <div class="chip" style="margin: 1rem auto;">Bomba ${bombNumber} / ${totalBombs}</div>
          <button class="btn-pill gray" @click=${this.leave} style="margin-top: 1rem;">
            <span class="label">SALIR</span>
          </button>
        </div>
      </div>
    `;
  }

  private leave = () => {
    this.dispatchEvent(new CustomEvent('jgz-leave', { bubbles: true, composed: true }));
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'jgz-waiting': JgzWaiting;
  }
}
